import { setAppConfig } from "./global.js";
import logger from "./logger.js";
import { refreshSession, identify, setPermissions, clearPermissions, clearSession, } from "./session.js";
import { trackEvent } from "./tracker.js";
export { SESSION_FIELDS } from "./session.js";
const initializeTracker = ({ userId = null, permissions, ...appConfig }) => {
    logger.log("Initializing tracking with", appConfig);
    const config = setAppConfig(appConfig);
    logger.log("Starting session with: ", { identify, permissions });
    if (userId)
        identify(userId);
    if (permissions)
        setPermissions(permissions);
    const session = refreshSession();
    logger.log("Tracking initialized");
    return {
        session,
        config,
        clearSession,
        clearPermissions,
        identify,
        setPermissions,
        trackEvent,
    };
};
export default initializeTracker;
